__turbopack_context__.v({
  "collapsed": "tags-module-scss-module__-Lh6GG__collapsed",
  "regular": "tags-module-scss-module__-Lh6GG__regular",
  "tags": "tags-module-scss-module__-Lh6GG__tags",
  "tags__button": "tags-module-scss-module__-Lh6GG__tags__button",
  "tags__button__active": "tags-module-scss-module__-Lh6GG__tags__button__active",
  "tags__list": "tags-module-scss-module__-Lh6GG__tags__list",
  "tools": "tags-module-scss-module__-Lh6GG__tools",
  "wide": "tags-module-scss-module__-Lh6GG__wide",
  "wideOnMobile": "tags-module-scss-module__-Lh6GG__wideOnMobile",
});
